export function isNumber(text) {
  if (typeof text === "undefined" || text == null) {
    return false;
  }
  return /^\d+$/.test(text);
}

export function slugify(text) {
  const decodedText = decodeTurkishCharacters(text);
  if (!decodedText) return undefined;
  return decodedText
    .replace(/[^-a-zA-Z0-9\s]+/gi, "") // remove non-alphanumeric chars
    .replace(/\s/gi, "-") // convert spaces to dashes
    .replace(/[-]+/gi, "-") // trim repeated dashes
    .toLowerCase();
}

const trMap = {
  çÇ: "c",
  ğĞ: "g",
  şŞ: "s",
  üÜ: "u",
  ıİ: "i",
  öÖ: "o",
};

export const decodeTurkishCharacters = (text) => {
  if (typeof text !== "string") return undefined;
  return Object.keys(trMap).reduce((acc, key) => acc.replace(new RegExp("[" + key + "]", "g"), trMap[key]), text);
};

export const cleanAndSlugify = (obj) => {
  const cleaned = Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== undefined && v !== null && v !== "undefined")
  );

  const toSlug = ["city", "town", "district", "project_name", "project_company_name"];
  for (const key of toSlug) {
    if (cleaned[key]) {
      cleaned[key] = slugify(cleaned[key]);
    }
  }

  return cleaned;
};
